import fvSubassembly from "../fvSubassembly"
export default class fvPolygonObj extends fvSubassembly{
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        // this.points.forEach(function(e) {
        //     e[0]-=this.borderWidth/2;
        //     e[1]-=this.borderWidth/2;
        // }.bind(this));
        this.regionHeight = this.height - 2*this.borderWidth;
        this.regionWidth = this.width -  2*this.borderWidth;
        this.moveWidth = this.borderWidth/2;
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
    init(){
        super.init();
        this.temp = Math.round(this.borderWidth/2);
        // 根据x y 因边框、缩放改变导致绘制多边形重新计算
        for(var i = 0; i<this.points.length; i++){
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX ;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY ;

            this.points[i][0] = points0* this.magnification.x;
            this.points[i][1] = points1* this.magnification.y;
            this.points[i][0] = this.points[i][0] ;
            this.points[i][1] = this.points[i][1] ;
        }
    }
    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.save();
        canvas.setLineDash(this.lineStyle(this.lineType));
        canvas.beginPath();
        if(this.color=="" || this.opacity<=0){
            canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
            canvas.strokeStyle = this.borderColor;
        }else{
            var rgbArray = this.color.colorRgb(this.opacity/255);;
            canvas.fillStyle = rgbArray;//矩形填充颜色
            if(this.borderWidth > 0){
                canvas.strokeStyle = this.borderColor;
            }else{
                canvas.strokeStyle = rgbArray;
            }

        }
        //设置线宽度
        if(this.borderWidth == 0){
            canvas.lineWidth = 0.01;
        }else{
            canvas.lineWidth = this.borderWidth;
        }
        if(this.renderType > 0){
            canvas.moveTo(parseFloat(this.cx + this.points[0][0]),parseFloat(this.cy + this.points[0][1]));
            for(var i = 1 ;i < this.points.length ; i++) {
                canvas.lineTo(parseFloat(this.cx + this.points[i][0]), parseFloat(this.cy + this.points[i][1]));
            }
            canvas.closePath();
            canvas.clip();
        }else{
            canvas.moveTo(parseFloat(this.cx + this.points[0][0]),parseFloat(this.cy + this.points[0][1]));
            for(var i = 1 ;i < this.points.length ; i++) {
                canvas.lineTo(parseFloat(this.cx + this.points[i][0]), parseFloat(this.cy + this.points[i][1]));
            }
            if(this.lineType >= 0){
              canvas.closePath();
            }
            if(this.opacity > 0){
                var rgbArray = this.color.colorRgb(this.opacity/255);
                this.color = rgbArray ;
            }else{
                var rgbArray1 = this.color.colorRgb(0.0001);
                this.color = rgbArray1;
            }
            if(this.lineType >= 0){
              canvas.fill();
            }
            canvas.stroke();
        }
        canvas.stroke();
        this.Render(canvas);
        if(this.lineTypeStyle){
			if(this.lineTypeStyle.isStereo){ 
				this.drawStereo(canvas);
			}
		}
        canvas.stroke();
        this.executePosAnimation(canvas)
        canvas.restore();
    }
    //绘制管道
	drawStereo(canvas){
		var byR0,byG0,byB0;
		var nR1,nG1,nB1;
		var Color = [];
		var rgbArr = [];
		rgbArr = this.borderColor.colorRgb();
		if(rgbArr.length != 3){
			byR0 = 0;
			byG0 = 0;
			byB0 = 255;
		}else{
			byR0 = rgbArr[0];
			byG0 = rgbArr[1];
			byB0 = rgbArr[2];
		}
		Color = this.lineTypeStyle.stereoColor.colorRgb();
		nR1 = Color[0];
		nG1 = Color[1];
		nB1 = Color[2];
		var fAddR,fAddG,fAddB;
		var w = Math.max(1,parseInt(this.borderWidth));
		fAddR = (nR1-byR0)/w;
		fAddG = (nG1-byG0)/w;
		fAddB = (nB1-byB0)/w;
		var i=0;
		var fWidthAdd;
		if(parseInt(this.borderWidth) <= 8){
			fWidthAdd = 2.0;
		}else{
			fWidthAdd = 2.0 * parseInt(this.borderWidth)/32.0 + 2.0;
		}
		i = -999;
		for(var fj =1.0; fj<=parseInt(this.borderWidth); fj+=fWidthAdd){
			// if((i == Math.ceil(fj)) || (i == Math.ceil(fj)))
            // continue;
			i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率
			var colorStyle = "rgb(";
			var tempr = byR0+fAddR*i>255?255:byR0+fAddR*i;
			var tempg = byG0+fAddG*i>255?255:byG0+fAddG*i;
			var tempb = byB0+fAddB*i>255?255:byB0+fAddB*i;
			colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
			canvas.strokeStyle = colorStyle;
            canvas.lineWidth = parseInt(this.borderWidth)+1 - i;
            canvas.moveTo(parseFloat(this.cx + this.points[0][0]),parseFloat(this.cy + this.points[0][1]));
            for(var i = 1 ;i < this.points.length ; i++) {
                canvas.lineTo(parseFloat(this.cx + this.points[i][0]), parseFloat(this.cy + this.points[i][1]));
            }
			canvas.stroke();
		}
	}

}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvPolygonObj.js